import { render, staticRenderFns } from "./info-down-about-slider.vue?vue&type=template&id=0bb959ba"
import script from "./info-down-about-slider.vue?vue&type=script&lang=js"
export * from "./info-down-about-slider.vue?vue&type=script&lang=js"
import style0 from "./info-down-about-slider.vue?vue&type=style&index=0&id=0bb959ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports